export default "__VITE_ASSET__DWUhYidj__"